
import MessageBox from "../MessageBox.vue";
import { User } from "../../../../../../domain/entities/entities";
import {
  computed,
  ComputedRef,
  defineComponent,
  onBeforeMount,
  PropType,
  Ref,
  ref
} from "vue";
import { isGTopTemplate } from "../../../mixins";

export default defineComponent({
  components: { MessageBox },
  props: {
    message: {
      required: true,
      type: String
    },
    animationIsReverse: {
      required: false,
      type: Boolean
    },
    user: {
      type: Object as PropType<User>,
      required: true
    }
  },
  setup({ user }, { emit }) {
    const isTransitionFinished = ref(false);

    const userName: Ref<string> = ref("Usuário");

    const newUser: Ref<User> = ref(new User());

    const platformNames: ComputedRef<string> = computed(() => {
      if (isGTopTemplate()) {
        return "Escola GTOP";
      } else {
        return "Decola";
      }
    });

    onBeforeMount(async () => {
      getFirstName();
    });

    const updateUser = (inputElement: HTMLInputElement) => {
      newUser.value = user;
      newUser.value.socialName = inputElement.value;
      emit("update:user", newUser.value);
    };

    const getFirstName = (): string => {
      if (user.socialName) {
        return (userName.value = user.socialName);
      } else if (user.name) {
        const endOfFirstName = user.name.indexOf(" ");
        return (userName.value = user.name.slice(0, endOfFirstName));
      }
      return userName.value;
    };

    const fluctuate = (): void => {
      if (!isTransitionFinished.value) {
        isTransitionFinished.value = true;
      }
    };

    return {
      isTransitionFinished,
      userName,
      platformNames,
      updateUser,
      getFirstName,
      fluctuate,
      isGTopTemplate
    };
  }
});
